import { create } from "zustand";

interface CentinelaLiveState {
  callingDeviceIds: string[];
  subscribedCompanyIds: string[];
  startCall: (deviceId: string | null) => void;
  endCall: (deviceId: string | null) => void;
  setSubscribed: (companyIds: string[]) => void;
  reset: () => void;
}

export const useCentinelaLiveStore = create<CentinelaLiveState>((set) => ({
  callingDeviceIds: [],
  subscribedCompanyIds: [],
  startCall: (deviceId) =>
    set((state) =>
      !deviceId || state.callingDeviceIds.includes(deviceId)
        ? state
        : { callingDeviceIds: [...state.callingDeviceIds, deviceId] },
    ),
  endCall: (deviceId) =>
    set((state) =>
      !deviceId
        ? state
        : { callingDeviceIds: state.callingDeviceIds.filter((id) => id !== deviceId) },
    ),
  setSubscribed: (companyIds) => set({ subscribedCompanyIds: companyIds }),
  reset: () => set({ callingDeviceIds: [], subscribedCompanyIds: [] }),
}));

export const useIsDeviceCalling = (deviceIds: string[]): boolean =>
  useCentinelaLiveStore((state) =>
    deviceIds.some((id) => state.callingDeviceIds.includes(id)),
  );
